import SolutionsPatients from "@/components/SolutionsPatients";

export default function Patients() {
  return (
    <div>
      <main>
        <SolutionsPatients />
      </main>
    </div>
  );
}